export const logo = require('./images/chemcharts.png');
export const background = require('./images/background.jpg');
export const linkedin = require('./images/linkedin.png');
export const search = require('./images/search.png');
export const graphs = require('./images/graphs.png');
export const convs = require('./images/convs.png');
export const mail = require('./images/mail.png');
export const falsks = require('./images/fasks.jpg');
export const menu = require('./images/menu.png');